import React from 'react';
import PropTypes from 'prop-types';

import FormManager from "src/core/gd-form/common/form-manager";
import ReassignUserTasks from "../reassign-items/tasks";
import ReassignUserEvents from "../reassign-items/events";
import ReassignUserProjects from "../reassign-items/projects";
import VScroll from "src/core/gd-components/scrolling/custom-v-scroll/v-scroll";
import ButtonSubmitDeprecated from "src/core/gd-form/common/btn-submit/btn-submit-ui5";
import Form from "core/gd-form/form/form-ui5/form";

export default class ModalUserReassign extends React.Component {
    static propTypes = {
        reassignType: PropTypes.oneOf(['reassign-access', 'reassign-delete']),
        projectUser: PropTypes.object,
        itemsToReassign: PropTypes.object,

        actions: PropTypes.object,
    }

    constructor(props) {
        super(props);

        this.canSubmit  = false;
        this.tasks      = _.uniqBy(this.props.itemsToReassign.taskAssignments, task=>task.id);
        this.events     = _.uniqBy(this.props.itemsToReassign.eventAssignments, event=>event.id);
        this.projects   = _.uniqBy(this.props.itemsToReassign.projectOwner, project=>project.id);

        const initFormData = {
            tasksReassignTo     : null,
            eventsReassignTo    : null,
            projectsReassignTo  : null,
        };

        const formStructure = {
            isFormChanged: true,
            fields: {
                tasksReassignTo:    {type: 'select',    /*isRequired: this.tasks.length > 0,*/      label: "Tasks Assignee",},
                eventsReassignTo:   {type: 'select',    isRequired: this.events.length > 0,     label: "Events Assignee"},
                projectsReassignTo: {type: 'select',    isRequired: this.projects.length > 0,   label: "Project owner"},
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);

        this.userOptions = _(gd.session.projectUsers.filterByProjectNotReadOnly(this.props.projectUser.projectId).models)
            .map(projectUser=>({
                value: projectUser.user.id,
                label: projectUser.user.name
            }))
            .filter(option=>option.value !== this.props.projectUser.userId)
            .value();
    }

    onSubmit = (result) => {
        this.props.actions.reassignUserItems(result.tasksReassignTo, result.eventsReassignTo, result.projectsReassignTo)
    }

    getInfo() {
        let res;

        const project = gd.session.projects.get(this.props.projectUser.projectId);
        const user = gd.session.users.get(this.props.projectUser.userId);

        switch (this.props.reassignType) {
            case 'reassign-delete':
                res = (
                    <div className="ui5-plate plate-error">
                        <p>You are about to delete <b>{user.name}</b> from <b>{project.name}</b> project.</p>
                        <p className="m-t-10">This user has open items that you need to re-assign to another project user before deleting.</p>
                    </div>
                );
                break;
            case 'reassign-access':
                res = (
                    <div className="ui5-plate plate-error">
                        <p>You are about to set the read-only access level for <b>{user.name}</b> in <b>{project.name}</b> project.</p>
                        <p className="m-t-10">Please re-assign active tasks/events/projects if applicable and click reassign button.</p>
                    </div>
                );
                break;
        }
        return res;
    }

    render() {
        const user = gd.session.users.get(this.props.projectUser.userId);

        let submitLabel = '';
        switch (this.props.reassignType) {
            case 'reassign-delete': submitLabel = 'Reassign & Delete'; break;
            case 'reassign-access': submitLabel = 'Reassign & Update'; break;
        }

        return (
            <React.Fragment>
                <div className="iv-header header-left header-small-no-separator">
                    <div className="title-line">
                        <div className="view-name">
                            <div className="view-name ui5-title-app-name">
                                {user.name}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="iv-content with-left-panel">
                    <VScroll>
                        <div className="ui5-info-panel big-panel m-l-30 m-r-30 m-t-10">
                            {this.getInfo()}

                            <Form>
                                <ReassignUserTasks form={this.form} tasks={this.tasks} userOptions={this.userOptions}/>
                                <ReassignUserEvents form={this.form} events={this.events} userOptions={this.userOptions}/>
                                <ReassignUserProjects form={this.form} projects={this.projects} userOptions={this.userOptions}/>
                            </Form>

                            <div className="fl-ac p-t-20 p-b-20" style={{paddingLeft: 160}}>
                                <ButtonSubmitDeprecated className="red" form={this.form} label={submitLabel}/>
                            </div>
                        </div>
                    </VScroll>
                </div>
            </React.Fragment>
        );
    }
}